export default __webpack_public_path__ + "static/media/Igus.2d6f3413.webp";